import { Box, Center, Flex, Image, Spinner, Text, useDisclosure, Button } from '@chakra-ui/react'
import Dropzone, { DropzoneInputProps, DropzoneRootProps, useDropzone } from 'react-dropzone'
import defaultPreviewImage from '../../Assets/defaultPreviewImage.png'
import { AiOutlineClose } from 'react-icons/ai'
import FilePreview from 'Core/FilePreview'
import { useCallback, useEffect, useState } from 'react'
import { FaCamera } from 'react-icons/fa'
import { Document, Page } from 'react-pdf'

interface FileUploadProps {
  id?: number | null
  uploadDesc?: string
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
  getInputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T
  preview: File | null | undefined
  previewUrl?: any | undefined
  inputFieldImage?: string
  customStyleBoxWidth?: string
  previewStyleLeft?: string
  handleFileCancel?: any
  isLoading: boolean
  onlyCameraAllowed?: boolean
  onFileDelete: React.Dispatch<React.SetStateAction<File | null>>
}
export const FileUploadandPreview = ({
  id,
  getRootProps,
  inputFieldImage,
  getInputProps,
  uploadDesc,
  preview,
  previewUrl,
  customStyleBoxWidth,
  previewStyleLeft,
  handleFileCancel,
  isLoading,
  onFileDelete,
  onlyCameraAllowed = false,
}: FileUploadProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return preview ? (
    <Box>
      <Box position='relative' justifyContent='center' alignItems='center' textAlign='center'>
        <Box position={'absolute'} top='0px' right='0px' margin={'10px'}>
          <Button
            px='15px'
            py='10px'
            border='1px solid white'
            rounded='3xl'
            onClick={() => {
              onFileDelete(null)
            }}
          >
            X
          </Button>
        </Box>
        <Box
          position='absolute'
          w={customStyleBoxWidth || '225px'}
          h='130px'
          bg='black'
          rounded='lg'
          width={'fit-content'}
          display='flex'
          justifyContent='center'
          alignContent={'center'}
        >
          {/* <Button color='white' onClick={()=>{
            console.log(preview)
            preview=null
            previewUrl=null
          }}>
            X
          </Button> */}
        </Box>
        <Box
          position='absolute'
          className='left-1/2 top-1/2'
          style={{ transform: 'translate(-50%,-50%)' }}
          border='1px solid white'
          rounded='3xl'
        >
          <Button
            rounded='3xl'
            cursor='pointer'
            onClick={onOpen}
            color='white'
            fontSize='sm'
            fontWeight='bold'
            w='200px'
            colorScheme='primary'
            variant={'solid'}
          >
            Preview
          </Button>

          <FilePreview
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            preview={preview}
            previewUrl={previewUrl}
          />
        </Box>
        <Box
          position='absolute'
          top='40%'
          left={previewStyleLeft || '50%'}
          border='1px solid white'
          rounded='xl'
        ></Box>

        <Box
          position='absolute'
          top='40%'
          left={previewStyleLeft || '50%'}
          border='1px solid white'
          rounded='xl'
        ></Box>

        <Box right='4' top='1' position='absolute'>
          {/* {(typeof (preview) !== 'string' || excludeIds.includes(id)) && <AiOutlineClose cursor='pointer' onClick={cancelHandler} color='white' />} */}
        </Box>
        {preview?.type === 'application/pdf' ? (
          <Box
            mt='20px'
            width={customStyleBoxWidth || '225px'}
            height='130px'
            overflow='hidden'
            borderRadius='10px'
            mb='20px'
          >
            <Document file={previewUrl || preview}>
              <Page
                pageNumber={1}
                width={parseInt(customStyleBoxWidth || '225')}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
          </Box>
        ) : (
          <Image
            width={customStyleBoxWidth || '225px'}
            h='130px'
            my='20px'
            rounded='lg'
            src={previewUrl}
          />
        )}
      </Box>
    </Box>
  ) : (
    <Box
      w={customStyleBoxWidth || '225px'}
      h='130px'
      my='4px'
      // my='20px'
      // mx='150px'
      bg='#F8F8F8'
      border='1px dashed #A5A5A5'
      rounded='lg'
      {...getRootProps()}
    >
      <Box pt='6'>
        <>
          <Center>
            {isLoading ? (
              <Spinner />
            ) : onlyCameraAllowed ? (
              <FaCamera size='60px' />
            ) : (
              <Image cursor='pointer' src={defaultPreviewImage} w='60px' h='60px' />
            )}
          </Center>
          <Center>
            <Text cursor='pointer' textAlign='center' fontSize='xs' mt='2' py='5px' color='#A5A5A5'>
              {uploadDesc}
            </Text>
          </Center>
          <input
            {...getInputProps()}
            capture={onlyCameraAllowed === true ? 'environment' : undefined}
          />
        </>
      </Box>
    </Box>
  )
}

export default FileUploadandPreview
